/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      if ( $( '.results__menu li' ).hasClass( 'active' ) ) {
        $( '.results__menu li.active' ).closest( '.results__sub-menu' ).addClass( 'open' ).show();
        $( '.results__menu li.active' ).closest( '.results__sub-menu' ).prev().addClass( 'open' );
      }

      if ( window.isMobile ) {
        $( '.results__menu-header' ).click( function() {
          $( '.results__menu' ).slideToggle();
          $( '.results__menu-header' ).toggleClass( 'open' );
        } );
      }

      $( '.results__menu > li' ).click( function() {
        $( this ).toggleClass( 'open' );
        if ( $( this ).next( '.results__sub-menu' ).hasClass( 'open' ) ) {
          $( this ).next( '.results__sub-menu' ).slideUp();
          $( this ).next( '.results__sub-menu' ).removeClass( 'open' );
        } else {
          $( '.results__sub-menu.open' ).slideUp();
          $( '.results__sub-menu.open' ).removeClass( 'open' );
          $( '.results__menu li.open' ).not( this ).removeClass( 'open' );
          $( this ).next( '.results__sub-menu' ).slideDown();
          $( this ).next( '.results__sub-menu' ).addClass( 'open' );
        }
      } );

      $( '.results__sub-menu li, .results__sub-menu li.all-treatments' ).click( function() {
        $( '.results__menu-header__title--mobile' ).text( $( this ).attr( 'data-title' ) );
        $( '.results__sub-menu li' ).removeClass( 'active' );
        $( this ).addClass( 'active' );

        if ( window.isMobile ) {
          $( '.results__menu' ).slideUp();
          $( '.results__menu-header' ).removeClass( 'open' );
        }

        $( '.results__gallery-wrapper' ).addClass( 'loading' );

        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_update_results_gallery',
              params: {
                result_treatment_id: $( this ).attr( 'data-treatment' ),
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                $( '.results__gallery-wrapper' ).removeClass( 'loading' );
                $( '.results__gallery-wrapper' ).html( data.response );
                app.components['ajax-results'].init();
              }
            }
        );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'results-page', COMPONENT );
} )( app );
